import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  CreateDispatchSummaryMarketInput,
  CreateDispatchSummaryMarketResponse,
  MutationCreateDispatchSummaryMarketBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { CreateDispatchSummaryMarket } from '@/features/SummaryHistory/api/queries/CreateDispatchSummaryMarket';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof CreateDispatchSummaryMarketInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<CreateDispatchSummaryMarketResponse>;
}

// CreateDispatchSummaryMarket Service
export const { createDispatchSummaryMarket, useCreateDispatchSummaryMarket } = ((): {
  createDispatchSummaryMarket: ServiceMethod;
  useCreateDispatchSummaryMarket: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(CreateDispatchSummaryMarket).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: CreateDispatchSummaryMarketInput[], options?: ConnectionOptions): Promise<CreateDispatchSummaryMarketResponse> => {
        const args: MutationCreateDispatchSummaryMarketBulkArgs = {
          input: {
            values: payload,
          },
        };
        const opts = { merge: options?.merge ? 'createDispatchSummaryMarketBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('createDispatchSummaryMarketBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    createDispatchSummaryMarket: fetch,
    useCreateDispatchSummaryMarket: useService,
  };
})();
